import { useCallback } from 'react';
import { FormInstance } from 'components';
import { useAttachmentTypeQuery } from 'api';
import { MicroserviceTypes } from 'typings';

export const useFilters = ({
  form,
  resetFilters,
  entityName,
  service,
}: {
  form: FormInstance;
  resetFilters: () => void;
  entityName: string;
  service?: MicroserviceTypes;
}) => {
  const { data: attachmentType = [] } = useAttachmentTypeQuery({ entityName, service });

  const clearFilters = useCallback(() => {
    form.resetFields();
    resetFilters();
  }, [form, resetFilters]);

  return {
    clearFilters,
    attachmentType,
  };
};
